var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C13.6562 6 15 4.65625 15 3C15 1.34375 13.6562 0 12 0C10.3438 0 9 1.34375 9 3C9 3.16875 9.01562 3.3375 9.04062 3.5L4.9875 5.75313C4.45938 5.28438 3.7625 5 3 5C1.34375 5 0 6.34375 0 8C0 9.65625 1.34375 11 3 11C3.7625 11 4.45625 10.7156 4.9875 10.2469L9.04062 12.5C9.0125 12.6625 9 12.8281 9 13C9 14.6562 10.3438 16 12 16C13.6562 16 15 14.6562 15 13C15 11.3438 13.6562 10 12 10C11.2375 10 10.5437 10.2844 10.0125 10.7531L5.95937 8.5C5.9875 8.3375 6 8.17188 6 8C6 7.82812 5.98437 7.6625 5.95937 7.5L10.0125 5.24687C10.5406 5.71562 11.2375 6 12 6Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.2123a8ee54aae5d07ddbe7f6a3bfe8fa.svg";
export { ForwardRef as ReactComponent };